import { render } from "./AEmpty.vue?vue&type=template&id=28ebb741&scoped=true"
import script from "./AEmpty.vue?vue&type=script&lang=js"
export * from "./AEmpty.vue?vue&type=script&lang=js"

import "./AEmpty.vue?vue&type=style&index=0&id=28ebb741&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ebb741"]])

export default __exports__